import React from "react";
import orangeIndicator from "@src/assets/svg/orange-color-indicator-icon.svg";
import { Button } from "@src/components/atoms/buttons/button/button";
import styles from "./ota-backup-process-in-progress.module.scss";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { useOtaBackupProcessInProgress } from "./use-ota-backup-process-in-progress";

const cssClassName = "ota-backup-process-in-progress";

interface OTABackupProcessInProgressProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}

export default function OTABackupProcessInProgress({
  activeInstallationData,
}: OTABackupProcessInProgressProps) {
  const { title, texts, handleShowDetails } = useOtaBackupProcessInProgress({
    activeInstallationData,
  });

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={orangeIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>{title}</span>
          <span className={styles[`${cssClassName}__description`]}>
            {texts.description}
          </span>
        </div>
      </div>

      <Button
        text={texts.showDetailsButtonText}
        variant="secondary"
        fun={handleShowDetails}
      />
    </div>
  );
}
